import React, { useState, useEffect } from "react";
import DoctorSpecialities from "../Home/Components/DoctorSpecialities";



const Listview = ({ article }) => {
    return (
        <dic className="d-flex">
            <div className="col-12 col-sm-12 col-md-12 col-xl-12" style={{ marginBottom: '40px' }}>
                <div className="dc-article d-flex" style={{ boxShadow: "black 2px 2px 10px -5px" }}>
                    <div className="dc-articleimg-container col-12 col-sm-12 col-md-4 col-xl-4" style={{ padding: '0px' }}>
                        <figure className="dc-articleimg">
                            <img decoding="async" src={`${process.env.REACT_APP_API_BASE_URL}${article.featured_image}` || "https://via.placeholder.com/545x389"} alt={article.title} style={{ objectFit: "cover", width: "100%", height: "200px" }} />
                            <figcaption>
                                <div className="dc-articlesdocinfo">
                                    {article.doctors && article.doctors.length > 0 ? (
                                        <>
                                            <img decoding="async" src={`${process.env.REACT_APP_API_BASE_URL}${article.doctors[0]?.profile_photo_url}` || "https://via.placeholder.com/30x30"} alt={article.doctors[0]?.display_name || "Doctor"} style={{ objectFit: "cover", width: "30px", height: "30px" }} />
                                            <span>{article.doctors[0]?.display_name || "Anonymous"}</span>
                                        </>

                                    ) : (
                                        <>
                                            <img decoding="async" src={`${process.env.REACT_APP_API_BASE_URL}${article.hospitals[0]?.profile_photo_url}` || "https://via.placeholder.com/30x30"} alt={article.hospitals[0]?.display_name || "Hospital"} style={{ objectFit: "cover", width: "30px", height: "30px" }} />
                                            <span>{article.hospitals[0]?.display_name || "Anonymous"}</span>
                                        </>
                                    )}
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                    <div className="dc-articlecontent-container col-12 col-sm-12 col-md-8 col-xl-8" style={{ padding: '0px' }}>
                        <div className="dc-articlecontent" style={{ height: '100%', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                            <div className="dc-title dc-ellipsis dc-titlep">
                                <DoctorSpecialities doctorId={article.categories} />
                                <h3>
                                    <a href={article.slug}>{article.title}</a>
                                </h3>
                                <span className="dc-datetime">
                                    <i className="lnr lnr-clock"></i>
                                    {new Date(article.created_at).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}
                                </span>
                            </div>
                            <ul className="dc-moreoptions">
                                <li className="dcget-likes" data-key={article.likeKey}>
                                    <a href="#" onClick={e => e.preventDefault()}>
                                        <i className="ti-heart"></i>{article.likes} {article.likes === 1 ? "Like" : "Likes"}
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={e => e.preventDefault()}>
                                        <i className="ti-eye"></i>{article.views} Views
                                    </a>
                                </li>
                                <li>
                                    <a href="#" onClick={e => e.preventDefault()}>
                                        <i className="ti-comment"></i>{article.comments_count} Comments
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </dic>

    );
}

export default Listview;
